import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import FormBeach from "../../FormBeach";
import { beachActions } from "../../../redux";

const BeachCreateUpdatePage: React.FC<RouteComponentProps<{ id?: string }>> = ({
  match,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (match.params.id) dispatch(beachActions.loadBeachById(match.params.id));
  }, [dispatch, match.params.id]);

  return <FormBeach />;
};

export default BeachCreateUpdatePage;
